import { KolSectionItemFragment } from '@graphqlTypes/sitecore';
import { withBasePath } from '@src/common/path-convert';
import { getFullImgPath } from '@src/utils/util';
import cn from 'classnames';

/** kol leaderboard rank */
const kolLeaderRank = (v: KolSectionItemFragment | null, lang: boolean) => {
    const imgLink = (v: string, rank: string) => {
        return getFullImgPath(`KolProfile/Ranking/${lang ? 'English/' : 'Chinese/'}${v}_${rank}`);
    };

    const rankList = [
        v?.rank_2nd?.value ? imgLink(v?.rank_2nd?.value, '2') : '',
        v?.rank_1st?.value ? imgLink(v?.rank_1st?.value, '1') : '',
        v?.rank_3rd?.value ? imgLink(v?.rank_3rd?.value, '3') : '',
    ];
    return (
        <div
            className='py-[10px] px-[10px] overflow-hidden relative'
            style={{
                height: '174px',
                backgroundImage: `url(${withBasePath(`/images/kol/home-BG.svg`)})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                overflow: 'hidden',
            }}
        >
            <img
                className={`${lang ? 'w-[57.575px]' : 'w-[42.54px]'}`}
                src={withBasePath(`/images/kol/i-TippingOne${lang ? '' : 'CH'}.svg`)}
                alt={''}
                loading='lazy'
            />
            <div className='w-full absolute bottom-[8.59px] left-0'>
                <div className='flex justify-center items-end'>
                    {rankList.map((i, index) => {
                        const sizeClasses = cn({
                            'h-[114.49px]': index === 0,
                            'h-[135.955px] mx-[16.23px]': index === 1,
                            'h-[107.33px]': index === 2,
                        });

                        const renderIcons = () => {
                            switch (index) {
                                case 0:
                                    return (
                                        <>
                                            {i && (
                                                <img
                                                    src={withBasePath(
                                                        '/images/kol/i-em-smileyFace.svg'
                                                    )}
                                                    alt=''
                                                    loading='lazy'
                                                    className='absolute z-10 w-[25.76px] top-[44.305px] left-[-7.02px]'
                                                />
                                            )}
                                        </>
                                    );
                                case 1:
                                    return (
                                        <>
                                            {i && (
                                                <>
                                                    <img
                                                        src={withBasePath(
                                                            '/images/kol/i-em-crown.svg'
                                                        )}
                                                        alt=''
                                                        loading='lazy'
                                                        className={cn(
                                                            'absolute z-10 w-[28.62px] top-[-14.245px] right-[7.29px]'
                                                        )}
                                                    />
                                                    <img
                                                        src={withBasePath(
                                                            '/images/kol/i-eml-love.svg'
                                                        )}
                                                        alt=''
                                                        loading='lazy'
                                                        className='absolute z-10 w-[14.31px] top-[77.345px] left-[22.45px]'
                                                    />
                                                    <img
                                                        src={withBasePath(
                                                            '/images/kol/i-emr-love.svg'
                                                        )}
                                                        alt=''
                                                        loading='lazy'
                                                        className='absolute z-10 w-[26.05px] top-[91.66px] right-[9.86px]'
                                                    />
                                                </>
                                            )}
                                        </>
                                    );
                                case 2:
                                    return (
                                        <>
                                            {i && (
                                                <img
                                                    src={withBasePath('/images/kol/i-em-horse.svg')}
                                                    alt=''
                                                    loading='lazy'
                                                    className='absolute z-10 w-[18.605px] top-[52.31px] left-[3.84px]'
                                                />
                                            )}
                                        </>
                                    );
                                default:
                                    return null;
                            }
                        };
                        return (
                            <div key={index} className='relative'>
                                <img src={i} alt={''} loading='lazy' className={sizeClasses} />
                                {renderIcons()}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default kolLeaderRank;
